import React from "react"
import styled from "styled-components"
import feature1 from "../images/feature1-new.png"
import feature2 from "../images/feature2-new.png"
import feature3 from "../images/feature3-new.png"

const features = [
  {
    tag: "01",
    title: "사용자 공유 템플릿",
    desc: "AI 느낌 없이, 7천여명의 사용자가 공유한 실용적인 템플릿을 바로 쓸 수 있어요.",
    image: feature1
  },
  {
    tag: "02",
    title: "본문 검색",
    desc: "상황만으로 찾기 어렵다면, 키워드로 본문 내용을 검색해 보세요.",
    image: feature2
  },
  {
    tag: "03",
    title: "필터와 정렬",
    desc: "대화상대, 언어, 길이순, 최근 복사순 등 원하는 조건으로 템플릿을 빠르게 찾을 수 있어요.",
    image: feature3
  }
]

export default function ServiceIntro() {
  return (
    <Section>
      <SectionLabel>How it works</SectionLabel>
      <SectionTitle>
        <strong>간단하게 찾고</strong> 바로 사용하세요
      </SectionTitle>
      <CardGrid>
        {features.map((f, i) => (
          <Card key={i}>
            <CardText>
              <CardTag>{f.tag}</CardTag>
              <CardTitle>{f.title}</CardTitle>
              <CardDesc>{f.desc}</CardDesc>
            </CardText>
            <CardImageArea>
              <CardImage src={f.image} alt={f.title} $index={i} />
            </CardImageArea>
          </Card>
        ))}
      </CardGrid>
    </Section>
  )
}

const Section = styled.div`
  padding: 96px 24px;
  text-align: center;
  background: #f5f5f7;

  @media (max-width: 800px) {
    padding: 64px 24px;
  }
`

const SectionLabel = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #5551ff;
  margin-bottom: 0;
  letter-spacing: -0.01em;
`

const SectionTitle = styled.h2`
  font-size: 32px;
  font-weight: 400;
  color: #0f0e2c;
  line-height: 140%;
  margin-bottom: 56px;

  strong {
    font-weight: 700;
  }

  @media (max-width: 800px) {
    font-size: 18px;
    margin-bottom: 40px;
  }
`

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  max-width: 1000px;
  margin: 0 auto;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
    max-width: 400px;
    gap: 16px;
  }
`

const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  text-align: left;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  }
`

const CardText = styled.div`
  padding: 28px 28px 0;
`

const CardTag = styled.p`
  font-family: "Space Grotesk", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #76767e;
  margin-bottom: 10px;
`

const CardTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #0f0e2c;
  margin-bottom: 10px;
  line-height: 130%;
`

const CardDesc = styled.p`
  font-size: 14px;
  color: #6b7280;
  line-height: 160%;
  word-break: keep-all;
`

const CardImageArea = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 24px 20px 0;
  overflow: hidden;
  min-height: 200px;

  @media (max-width: 800px) {
    min-height: 180px;
  }
`

const CardImage = styled.img`
  width: 85%;
  height: auto;
  object-fit: contain;
  transform: perspective(800px)
    rotateY(
      ${({ $index }) =>
        $index === 0 ? "-3deg" : $index === 1 ? "0deg" : "3deg"}
    )
    rotateX(2deg);
  transition: transform 0.3s ease;

  ${Card}:hover & {
    transform: perspective(800px) rotateY(0deg) rotateX(0deg) translateY(-4px);
  }
`
